import { render, staticRenderFns } from "./TerminosCondiciones.vue?vue&type=template&id=12b0f8ac&scoped=true"
import script from "./TerminosCondiciones.vue?vue&type=script&lang=js"
export * from "./TerminosCondiciones.vue?vue&type=script&lang=js"
import style0 from "./TerminosCondiciones.vue?vue&type=style&index=0&id=12b0f8ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b0f8ac",
  null
  
)

export default component.exports